import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { SnackbarService } from '../../core/services';
import { PlatformDashboardApi } from './platform-dashboard.api';
import * as PlatformDashboardActions from './platform-dashboard.actions';

@Injectable()
export class PlatformDashboardEffects {
  private readonly actions$ = inject(Actions);
  private readonly api = inject(PlatformDashboardApi);
  private readonly snackbar = inject(SnackbarService);

  loadDashboard$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PlatformDashboardActions.PlatformDashboardLoadRequest),
      switchMap(() =>
        this.api.getDashboard().pipe(
          map((response) => PlatformDashboardActions.PlatformDashboardLoadSuccess({ data: response?.data ?? null })),
          catchError((error) => of(PlatformDashboardActions.PlatformDashboardLoadFailure({
            error: error?.error?.message || error?.message || 'Failed to load platform dashboard',
          }))),
        ),
      ),
    ),
  );

  loadDashboardFailure$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(PlatformDashboardActions.PlatformDashboardLoadFailure),
        map(({ error }) => {
          this.snackbar.showNotification('error', '', `Failed to fetch platform dashboard: ${error}`, 'Close');
        }),
      ),
    { dispatch: false },
  );
}
